import { Box, Grid, IconButton, Typography } from '@mui/material';
import JobInterviewScheduleSheet from '../../JobInterviewScheduleSheet/JobInterviewScheduleSheet';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { COLORS } from '../../../utils/colors';

interface JobInterviewScheduleModalProps {
  open: boolean;
  onClose: Function;
  jobId: string;
}

const JobInterviewScheduleModal = (props: JobInterviewScheduleModalProps) => {
  const { open, onClose, jobId } = props;

  return (
    <Dialog
      fullWidth
      maxWidth={'md'}
      open={open}
      onClose={() => {
        onClose();
      }}
      PaperProps={{ sx: { borderRadius: '14px' } }}>
      <DialogTitle height={70} borderBottom={`1px solid ${COLORS.palette.borderColor}`}>
        <Grid container direction='row' justifyContent='space-between' alignItems='center' marginBottom='20px'>
          <Box>
            <Typography variant='h6'>Schedule Interview</Typography>
            <Typography variant='body2'>Select Clients to Schedule Interviews in this Job Opportunity.</Typography>
          </Box>
          <IconButton
            onClick={() => {
              onClose();
            }}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Box>
          <JobInterviewScheduleSheet
            jobId={jobId}
            onSubmit={() => {
              onClose();
            }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default JobInterviewScheduleModal;
